



















import { Component, Vue, Prop } from 'vue-property-decorator'
import moduleHeader from '@/components/moduleHeader/index.vue'
import calcModule from './calcModule.vue'
import { fetchIasDetail, saveIasGroup } from '@/api/tenant/calcGroup'
import { SaveCalcGroupParams, BranchObj, BranchItem } from '@/types/tenant/calcGroup'
import { cloneDeep } from 'lodash'

@Component({
  name: 'storyListCom',
  components: {
    moduleHeader,
    calcModule,
  }
})
export default class extends Vue {
    @Prop() dataObj!: { getListUrl: string; directUrl: string }
    activeName = '1'
    calcModule = calcModule
    requredArr = ['退休规划']
    dataSource: SaveCalcGroupParams = {
    }

    cloneDataSource: SaveCalcGroupParams = {}
    groupId = ''
    tabs = [
      {
        label: '运算模块选择',
        name: '1',
        mType: 'computeModelTree',
        mName: 'calcModule'
      },
      {
        label: '产品模块选择',
        name: '2',
        mType: 'productModelTree',
        mName: 'calcModule'
      }
    ]

    async created () {
      this.groupId = this.$route.query.id as string
      this.fetchTreeData()
    }

    async fetchTreeData () {
      const res = await fetchIasDetail({ id: this.groupId })
      if (res.statusCode === 0 && res.data) {
        console.log('33', res.data)
        this.dataSource = res.data
        this.cloneDataSource = cloneDeep(res.data)
      }
    }

    cancel () {
      // this.dataSource = cloneDeep(this.cloneDataSource)
      this.$router.back()
    }

    computedTreeChange (data: BranchObj, type: string) {
      if (type === 'calcModule') {
        (this.dataSource as SaveCalcGroupParams).computeModelTree = data
      }

      if (type === 'proModule') {
        (this.dataSource as SaveCalcGroupParams).productModelTree = data
      }

      console.log('data1010', data)
      console.log('p2 type', type)
    }

    filterCheck () {
      const selectArr: {id: string}[] = []
      const filterData = (dataObj: BranchObj | BranchItem) => {
        const itemArr = (dataObj as BranchObj).branch || (dataObj as BranchItem).subBranch
        itemArr && itemArr.forEach((item: BranchItem) => {
          if (item.selected && item.id) {
            selectArr.push({ id: item.id })
          }
          filterData(item)
        })
      }
      filterData(this.dataSource.computeModelTree as BranchObj)
      filterData(this.dataSource.productModelTree as BranchObj)
      console.log('selectArr', selectArr)
      return selectArr
    }

    computedCheck (treeObj: BranchObj, type: string) {
      const checkItemArr: BranchItem[] = []
      const computedFilter = (data: BranchObj | BranchItem) => {
        const branchData = (data as BranchObj).branch || (data as BranchItem).subBranch
        branchData && branchData.forEach(itemData => {
          if (type === 'computed') {
            this.requredArr.forEach(requiedItem => {
              if (itemData.name === requiedItem) {
                checkItemArr.push(itemData)
              }
            })
          }

          if (type === 'product' && itemData.id) {
            checkItemArr.push(itemData)
          }
          computedFilter(itemData)
        })
      }
      computedFilter(treeObj)
      return checkItemArr
    }

    validComputed (computedArr: BranchItem[]) {
      return computedArr.every(item => {
        return item.subBranch.some(branchItem => branchItem.selected)
      })
    }

    validCheck () {
      const computedArr = this.computedCheck(this.dataSource.computeModelTree as BranchObj, 'computed')
      const computedFlag = this.validComputed(computedArr)
      const productArr = this.computedCheck(this.dataSource.productModelTree as BranchObj, 'product')
      const productFlag = productArr.some((item: BranchItem) => item.selected)
      console.log('computedFlag', computedFlag)
      console.log('productArr', productArr)
      return productFlag && computedFlag
    }

    async save () {
      if (!this.validCheck()) {
        this.$message.error('请完整勾选运算组')
        return
      }
      this.dataSource.iasPageInfoList = this.filterCheck()
      const res = await saveIasGroup(this.dataSource)
      if (res.statusCode === 0 && res.data) {
        // this.fetchTreeData()
        this.$router.back()
        this.$message({
          type: 'success',
          message: '操作成功'
        })
      }
    }
}
